export default "//cloud.imgsmail.ru/cloud.mail.ru/187531/img/build/quota-landing/deleteLettersMobile.png";